











export default
  props:
    labels:
      type: Object
